/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Seo_Api_Q_EndpointsInputs */

const en_seo_api_q_endpoints = /** @type {(inputs: Seo_Api_Q_EndpointsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Which ${i?.name} endpoints does AnyAPI support?`)
};

const zh_hans1_seo_api_q_endpoints = /** @type {(inputs: Seo_Api_Q_EndpointsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI 支持哪些 ${i?.name} 接口？`)
};

const pt_br2_seo_api_q_endpoints = /** @type {(inputs: Seo_Api_Q_EndpointsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quais endpoints para ${i?.name} a AnyAPI oferece?`)
};

const es_seo_api_q_endpoints = /** @type {(inputs: Seo_Api_Q_EndpointsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Qué endpoints de ${i?.name} admite AnyAPI?`)
};

const fr_seo_api_q_endpoints = /** @type {(inputs: Seo_Api_Q_EndpointsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quels endpoints ${i?.name} AnyAPI prend-il en charge ?`)
};

const de_seo_api_q_endpoints = /** @type {(inputs: Seo_Api_Q_EndpointsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Welche ${i?.name}-Endpoints unterstützt AnyAPI?`)
};

const ru_seo_api_q_endpoints = /** @type {(inputs: Seo_Api_Q_EndpointsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Какие эндпоинты ${i?.name} поддерживает AnyAPI?`)
};

const it_seo_api_q_endpoints = /** @type {(inputs: Seo_Api_Q_EndpointsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quali endpoint di ${i?.name} supporta AnyAPI?`)
};

/**
* | output |
* | --- |
* | "Which {name} endpoints does AnyAPI support?" |
*
* @param {Seo_Api_Q_EndpointsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_api_q_endpoints = /** @type {((inputs: Seo_Api_Q_EndpointsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Api_Q_EndpointsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_api_q_endpoints(inputs)
	if (locale === "pt-BR") return pt_br2_seo_api_q_endpoints(inputs)
	if (locale === "es") return es_seo_api_q_endpoints(inputs)
	if (locale === "fr") return fr_seo_api_q_endpoints(inputs)
	if (locale === "de") return de_seo_api_q_endpoints(inputs)
	if (locale === "ru") return ru_seo_api_q_endpoints(inputs)
	if (locale === "it") return it_seo_api_q_endpoints(inputs)
	return en_seo_api_q_endpoints(inputs)
});